import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  
  downloadRepConsolidatedXlsx(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/show_process/${organization_id}/download_rep_consolidated_xlsx/${harvest_process_id}`, { responseType: 'blob' }
    );
  },

  fetchExportedBatchesTotal(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/show_process/${organization_id}/fetch_exported_batches_total/${harvest_process_id}`
    );
  },
  
  fetchExportedBatches(organization_id, harvest_process_id, current_page, rows_per_page) {
    return RequesterV1.get(
      `organization/process/harvest_export/show_process/${organization_id}/fetch_exported_batches/${harvest_process_id}/${current_page}/${rows_per_page}`
    );
  },
  
  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/show_process/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },

  filterExportedBatches(organization_id, harvest_process_id, filters) {
    var str = Object.keys(filters)
      .filter(key => filters[key] != null)
      .map(key => {
        return `${key}=${encodeURIComponent(filters[key])}`
      })
      .join("&");
    return RequesterV1.get(
      `organization/process/harvest_export/show_process/${organization_id}/filter_exported_batches/${harvest_process_id}?${str}`
    );
  },

  downloadRepHarvestXlsx(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/show_process/${organization_id}/download_rep_harvest_xlsx/${harvest_process_id}`, { responseType: 'blob' }
    );
  },
  
  downloadRepPackingXlsx(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/show_process/${organization_id}/download_rep_packing_xlsx/${harvest_process_id}`, { responseType: 'blob' }
    );
  },
  
}
